import $api from "@/assets/js/api.js";
import $h from "@/assets/js/helpers.js";
import $router from "@/router";
import $errors from "@/assets/js/errors.js";
import $moment from "moment-timezone";

const state = {
  activityFeedItems: {
    data: {},
    items: [],
  },
  activityFeedFileDownloads: {
    data: {},
    items: [],
  },
  activityFeedFileUploads: {
    data: {},
    items: [],
  },
  activityFeedFilePreviews: {
    data: {},
    items: [],
  },
  activityFeedPageViews: {
    data: {},
    items: [],
  },
  activityFeedProjectMessages: {
    data: {},
    items: [],
  },
  activityFeedProjectFileSignings: {
    data: {},
    items: [],
  },
  activityFeedFormResponses: {
    data: {},
    items: [],
  },
  activityFeedItemsGrouped: {
    data: {},
    items: [],
  },
  activityFeedItemsLineChart: {
    data: {},
    days: [],
    maxValue: 0,
  },
  activityFeedItemsForDropdown: {
    data: {},
    items: [],
  },
};

const getters = {
  projects_get_activity_feed_items: (state) => {
    return state.activityFeedItems;
  },
  projects_get_activity_feed_filedownloads: (state) => {
    return state.activityFeedFileDownloads;
  },
  projects_get_activity_feed_fileuploads: (state) => {
    return state.activityFeedFileUploads;
  },
  projects_get_activity_feed_filepreviews: (state) => {
    return state.activityFeedFilePreviews;
  },
  projects_get_activity_feed_pageviews: (state) => {
    return state.activityFeedPageViews;
  },
  projects_get_activity_feed_projectmessages: (state) => {
    return state.activityFeedProjectMessages;
  },
  projects_get_activity_feed_projectfilesignings: (state) => {
    return state.activityFeedProjectFileSignings;
  },
  projects_get_activity_feed_form_responses: (state) => {
    return state.activityFeedFormResponses;
  },
  projects_get_activity_feed_items_grouped: (state) => {
    return state.activityFeedItemsGrouped;
  },
  projects_get_activity_feed_items_line_chart: (state) => {
    return state.activityFeedItemsLineChart;
  },
  projects_get_activity_feed_items_for_dropdown: (state) => {
    return state.activityFeedItemsForDropdown;
  },
};

const mutations = {
  PROJECTS_SET_ACTIVITY_FEED_FILEDOWNLOADS(state, feeds) {
    feeds.items.forEach((obj) => {
      let feed = {};
      const arr = [];
      obj.events.FileDownload.forEach((o) => {
        feed.client = obj.client;
        feed.project = obj.project;
        feed.item = o;
        feed.uid = $h.createUniqueUid();
        arr.push(feed);
        feed = {};
      });
      state.activityFeedFileDownloads.items = state.activityFeedFileDownloads.items.concat(arr);
    });
    state.activityFeedFileDownloads.data = feeds;
    delete state.activityFeedFileDownloads.data.items;
  },
  PROJECTS_SET_ACTIVITY_FEED_FILEUPLOADS(state, feeds) {
    feeds.items.forEach((obj) => {
      let feed = {};
      const arr = [];
      obj.events.FileUpload.forEach((o) => {
        feed.client = obj.client;
        feed.project = obj.project;
        feed.item = o;
        feed.uid = $h.createUniqueUid();
        arr.push(feed);
        feed = {};
      });
      state.activityFeedFileUploads.items = state.activityFeedFileUploads.items.concat(arr);
    });
    state.activityFeedFileUploads.data = feeds;
    delete state.activityFeedFileUploads.data.items;
    console.log(">>>>>>>>>>>>>>> state.activityFeedFileUploads", state.activityFeedFileUploads);
  },
  PROJECTS_SET_ACTIVITY_FEED_FILEPREVIEWS(state, feeds) {
    feeds.items.forEach((obj) => {
      let feed = {};
      const arr = [];
      obj.events.FilePreview.forEach((o) => {
        feed.client = obj.client;
        feed.project = obj.project;
        feed.item = o;
        feed.uid = $h.createUniqueUid();
        arr.push(feed);
        feed = {};
      });
      state.activityFeedFilePreviews.items = state.activityFeedFilePreviews.items.concat(arr);
    });
    state.activityFeedFilePreviews.data = feeds;
    delete state.activityFeedFilePreviews.data.items;
  },
  PROJECTS_SET_ACTIVITY_FEED_PAGEVIEWS(state, feeds) {
    feeds.items.forEach((obj) => {
      let feed = {};
      const arr = [];
      obj.events.PageView.forEach((o) => {
        feed.client = obj.client;
        feed.project = obj.project;
        feed.item = o;
        feed.uid = $h.createUniqueUid();
        arr.push(feed);
        feed = {};
      });
      state.activityFeedPageViews.items = state.activityFeedPageViews.items.concat(arr);
    });
    state.activityFeedPageViews.data = feeds;
    delete state.activityFeedPageViews.data.items;
  },
  PROJECTS_SET_ACTIVITY_FEED_PROJECTMESSAGES(state, feeds) {
    feeds.items.forEach((obj) => {
      let feed = {};
      const arr = [];
      obj.events.ProjectMessage.forEach((o) => {
        feed.client = obj.client;
        feed.project = obj.project;
        feed.item = o;
        feed.uid = $h.createUniqueUid();
        arr.push(feed);
        feed = {};
      });
      state.activityFeedProjectMessages.items = state.activityFeedProjectMessages.items.concat(arr);
    });
    state.activityFeedProjectMessages.data = feeds;
    delete state.activityFeedProjectMessages.data.items;
  },
  PROJECTS_SET_ACTIVITY_FEED_PROJECTFILESIGNINGS(state, feeds) {
    feeds.items.forEach((obj) => {
      let feed = {};
      const arr = [];
      obj.events.ProjectFileSigned.forEach((o) => {
        feed.client = obj.client;
        feed.project = obj.project;
        feed.item = o;
        feed.uid = $h.createUniqueUid();
        arr.push(feed);
        feed = {};
      });
      state.activityFeedProjectFileSignings.items = state.activityFeedProjectFileSignings.items.concat(arr);
    });
    state.activityFeedProjectFileSignings.data = feeds;
    delete state.activityFeedProjectFileSignings.data.items;
  },
  PROJECTS_SET_ACTIVITY_FEED_FORMRESPONSES(state, feeds) {
    feeds.items.forEach((obj) => {
      let feed = {};
      const arr = [];
      obj.events.FormResponse.forEach((o) => {
        feed.client = obj.client;
        feed.project = obj.project;
        feed.item = o;
        feed.uid = $h.createUniqueUid();
        arr.push(feed);
        feed = {};
      });
      state.activityFeedFormResponses.items = state.activityFeedFormResponses.items.concat(arr);
    });
    state.activityFeedFormResponses.data = feeds;
    delete state.activityFeedFormResponses.data.items;
  },
  PROJECTS_SET_ACTIVITY_FEED_ITEMS(state, feeds) {
    feeds.items.forEach((obj) => {
      let feed = {};
      obj.events.FileDownload.forEach((o) => {
        feed.type = "fileDownloads";
        feed.client = obj.client;
        feed.project = obj.project;
        feed.item = o;
        state.activityFeedItems.items.push(feed);
        feed = {};
      });
      obj.events.FileUpload.forEach((o) => {
        feed.type = "fileUploads";
        feed.client = obj.client;
        feed.project = obj.project;
        feed.item = o;
        state.activityFeedItems.items.push(feed);
        feed = {};
      });
      obj.events.FilePreview.forEach((o) => {
        feed.type = "filePreviews";
        feed.client = obj.client;
        feed.project = obj.project;
        feed.item = o;
        state.activityFeedItems.items.push(feed);
        feed = {};
      });
      obj.events.PageView.forEach((o) => {
        feed.type = "pageViews";
        feed.client = obj.client;
        feed.project = obj.project;
        feed.item = o;
        state.activityFeedItems.items.push(feed);
        feed = {};
      });
      obj.events.ProjectFileSigned.forEach((o) => {
        feed.type = "projectFileSignings";
        feed.client = obj.client;
        feed.project = obj.project;
        feed.item = o;
        state.activityFeedItems.items.push(feed);
        feed = {};
      });
      obj.events.ProjectMessage.forEach((o) => {
        feed.type = "projectMessages";
        feed.client = obj.client;
        feed.project = obj.project;
        feed.item = o;
        state.activityFeedItems.items.push(feed);
        feed = {};
      });
      obj.events.FormResponse.forEach((o) => {
        feed.type = "formResponses";
        feed.client = obj.client;
        feed.project = obj.project;
        feed.item = o;
        state.activityFeedItems.items.push(feed);
        feed = {};
      });
    });
    state.activityFeedItems.items.sort((a, b) =>
      a.item.created_at < b.item.created_at ? 1 : b.item.created_at < a.item.created_at ? -1 : 0
    );
    state.activityFeedItems.data = feeds;
    delete state.activityFeedItems.data.items;
  },
  PROJECTS_SET_ACTIVITY_FEED_ITEMS_FOR_DROPDOWN(state, feeds) {
    feeds.items = feeds.items.slice(0, 5);
    state.activityFeedItemsForDropdown = feeds;
  },
  PROJECTS_SET_ACTIVITY_FEED_ITEMS_GROUPED(state, feeds) {
    state.activityFeedItemsGrouped.items = state.activityFeedItemsGrouped.items.concat(feeds.items);
    state.activityFeedItemsGrouped.data = feeds;
    delete state.activityFeedItemsGrouped.data.items;
    for (let i = 0; i < state.activityFeedItemsGrouped.items.length; i += 1) {
      if (!state.activityFeedItemsGrouped.items[i].timeline) {
        Object.keys(state.activityFeedItemsGrouped.items[i].events).forEach((key) => {
          for (let ii = 0; ii < state.activityFeedItemsGrouped.items[i].events[key].length; ii += 1) {
            let evt = state.activityFeedItemsGrouped.items[i].events[key][ii];
            if (evt) evt["key"] = key;
            if (!state.activityFeedItemsGrouped.items[i].timeline) {
              state.activityFeedItemsGrouped.items[i].timeline = [];
            }
            state.activityFeedItemsGrouped.items[i].timeline.push(evt);
          }
          if (state.activityFeedItemsGrouped.items[i].timeline) {
            state.activityFeedItemsGrouped.items[i].timeline.sort((a, b) => {
              let keyA = new Date(a.created_at),
                keyB = new Date(b.created_at);
              if (keyA < keyB) return 1;
              if (keyA > keyB) return -1;
              return 0;
            });
          }
        });
      }
    }
  },
  PROJECTS_SET_ACTIVITY_FEED_ITEMS_LINE_CHART(state, data) {
    let key = "";
    let hour = 0;
    let obj = {};
    let days = [];
    if (data.feeds.events_count > 0) {
      data.feeds.items.forEach((item) => {
        Object.entries(item.events).forEach((entry) => {
          entry[1].forEach((event) => {
            key = $moment(event.created_at).format("YYYY-MM-DD");
            hour = $moment(event.created_at).tz(data.timezone).hours();
            if (!Object.prototype.hasOwnProperty.call(obj, key)) {
              days.push(key);
              obj[key] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            }
            obj[key][hour] += 1;
          });
        });
      });
      state.activityFeedItemsLineChart.data = { ...state.activityFeedItemsLineChart.data, ...obj };
      state.activityFeedItemsLineChart.days = state.activityFeedItemsLineChart.days.concat(
        days.sort((date1, date2) => new Date(date2) - new Date(date1))
      );
      state.activityFeedItemsLineChart.days = state.activityFeedItemsLineChart.days.filter((item, index) => {
        return state.activityFeedItemsLineChart.days.indexOf(item) == index;
      });
    }
    Object.entries(state.activityFeedItemsLineChart.data).forEach((entry) => {
      let maxVal = Math.max.apply(null, entry[1]);
      if (state.activityFeedItemsLineChart.maxValue < maxVal) {
        if (maxVal < 10) {
          maxVal += 10;
        }
        if (!Number.isInteger(maxVal)) {
          maxVal = Math.round(maxVal / 10) * 10;
        }
        state.activityFeedItemsLineChart.maxValue = maxVal += 5;
      }
    });
  },
  PROJECTS_RESET_ACTIVITY_FEED_ITEMS_LINE_CHART(state) {
    state.activityFeedItemsLineChart = {
      data: {},
      days: [],
      maxValue: 0,
    };
  },
  PROJECTS_RESET_ACTIVITY_FEEDS(state) {
    state.activityFeedItems = {
      data: {},
      items: [],
    };
    state.activityFeedFileDownloads = {
      data: {},
      items: [],
    };
    state.activityFeedFileUploads = {
      data: {},
      items: [],
    };
    state.activityFeedFilePreviews = {
      data: {},
      items: [],
    };
    state.activityFeedPageViews = {
      data: {},
      items: [],
    };
    state.activityFeedProjectMessages = {
      data: {},
      items: [],
    };
    state.activityFeedProjectFileSignings = {
      data: {},
      items: [],
    };
    state.activityFeedFormResponses = {
      data: {},
      items: [],
    };
    state.activityFeedItemsGrouped = {
      data: {},
      items: [],
    };
  },
};

const actions = {
  /**
   * Execute an API call for the activity feed end point.
   * The following actions are supported:
   *
   * - activitiesList
   *
   * @param commit
   * @param dispatch
   * @param rootState
   * @param payload
   * @param apiMethod
   * @returns {*}
   */
  activityFeedsApiRequest({ commit, dispatch, rootState }, payload = {}) {
    if (!payload.data) {
      payload.data = {};
    }

    console.log("activityFeedsApiRequest: ", payload);

    return new Promise((resolve, reject) => {
      //!payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          let apiMethod = payload.apiMethod;
          let promise;

          if (apiMethod === "activitiesList") {
            promise = $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig).teamFeedsActivityGet(
              params
            );
          } else {
            console.log("invalid api method: " + apiMethod);
            reject("invalid api method: " + apiMethod);
          }

          promise
            .then((res) => {
              console.log("response of '" + apiMethod + "': ", res);
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },

  getProjectsActivityFeeds({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        from: payload.params.from ? payload.params.from : "",
        event_type: payload.params.event_type ? payload.params.event_type : "",
        client_uid: payload.params.client_uid ? payload.params.client_uid : "",
        project_uid: payload.params.project_uid ? payload.params.project_uid : "",
      };
      dispatch("prepareRequest", payload.params, $router.currentRoute.params.team)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFeedsActivityGet(params)
            .then((res) => {
              console.log("teamFeedsActivityGet", res, payload.params.event_type);
              payload.type === "Dropdown" && commit("PROJECTS_SET_ACTIVITY_FEED_ITEMS_FOR_DROPDOWN", res.data.data);
              payload.type === "Sorted" && commit("PROJECTS_SET_ACTIVITY_FEED_ITEMS", res.data.data);
              payload.type === "Grouped" && commit("PROJECTS_SET_ACTIVITY_FEED_ITEMS_GROUPED", res.data.data);
              payload.type === "line-chart" &&
                commit("PROJECTS_SET_ACTIVITY_FEED_ITEMS_LINE_CHART", {
                  feeds: res.data.data,
                  timezone: payload.timezone,
                });
              payload.params.event_type === "FileDownload" &&
                commit("PROJECTS_SET_ACTIVITY_FEED_FILEDOWNLOADS", res.data.data);
              payload.params.event_type === "FileUpload" &&
                commit("PROJECTS_SET_ACTIVITY_FEED_FILEUPLOADS", res.data.data);
              payload.params.event_type === "FilePreview" &&
                commit("PROJECTS_SET_ACTIVITY_FEED_FILEPREVIEWS", res.data.data);
              payload.params.event_type === "PageView" && commit("PROJECTS_SET_ACTIVITY_FEED_PAGEVIEWS", res.data.data);
              payload.params.event_type === "ProjectMessage" &&
                commit("PROJECTS_SET_ACTIVITY_FEED_PROJECTMESSAGES", res.data.data);
              payload.params.event_type === "ProjectFileSigned" &&
                commit("PROJECTS_SET_ACTIVITY_FEED_PROJECTFILESIGNINGS", res.data.data);
              payload.params.event_type === "FormResponse" &&
                commit("PROJECTS_SET_ACTIVITY_FEED_FORMRESPONSES", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
